import { EArrowsSize, EControlType, ESizeType } from '@cian/frontend-newbuilding-carousel-component';
export var SLIDER_MEDIA = {
  minWidth: -Infinity,
  maxWidth: Infinity,
  settings: {
    draggable: true,
    elementsWidth: {
      leftEar: {
        width: 0,
        type: ESizeType.PIXEL
      },
      rightEar: {
        width: 0,
        type: ESizeType.PERCENT
      },
      content: {
        width: 100,
        type: ESizeType.PERCENT
      },
      gap: {
        width: 0,
        type: ESizeType.PIXEL
      }
    },
    height: {
      value: 100,
      type: ESizeType.PERCENT
    },
    slidesToShow: 1,
    slidesToScroll: 1,
    defaultControls: [{
      type: EControlType.ARROWS
    }],
    arrowsSettings: {
      alwaysVisible: true,
      size: EArrowsSize.LARGE
    }
  }
};
export var SLIDER_FIRST_PAINT = {
  draggable: true,
  elementsWidth: {
    leftEar: {
      width: 0,
      type: ESizeType.PIXEL
    },
    rightEar: {
      width: 0,
      type: ESizeType.PERCENT
    },
    content: {
      width: 100,
      type: ESizeType.PERCENT
    },
    gap: {
      width: 0,
      type: ESizeType.PIXEL
    }
  },
  height: {
    value: 100,
    type: ESizeType.PERCENT
  },
  slidesToShow: 1,
  defaultControls: [{
    type: EControlType.ARROWS
  }],
  arrowsSettings: {
    alwaysVisible: true,
    size: EArrowsSize.LARGE
  }
};
export var DEFAULT_OPTIONS = {};